export function CompareNodes(a, b) {
  var ac = a.GetDataObjID();
  var bc = b.GetDataObjID();

  if (ac == bc) return 0;
  else if (ac > bc) return 1;

  return -1;
}
